import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link as RouterLink } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";

import { DEV_API_DOC_GET_LIST_URL } from "../../../config";
import makeApiRequest from "../../../utils/axios/new-axios";
import { showErrorAlert } from "../../../store/actions/alerts";
import ComponentLoader from "../../../components/loader/ComponentLoader";
import StatusChip from "../../../components/chips/StatusChip";
import { usePageTitle } from "../../../utils/pageTitle";

const useStyles = makeStyles(theme => ({
    paper: {
        width: "100%",
        overflowX: "auto",
        marginBottom: theme.spacing(2),
        padding: "15px"
    }
}));

export default function ApiDocsList() {
    const classes = useStyles();
    const dispatch = useDispatch();
    usePageTitle("API Docs");

    const [docs, setDocs] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        makeApiRequest({
            url: DEV_API_DOC_GET_LIST_URL.url,
            method: DEV_API_DOC_GET_LIST_URL.method,
        }).then(response => {
            setDocs(response.data);
            setIsLoading(false);
        }).catch((error) => {
            setIsLoading(false);
            dispatch(
                showErrorAlert(
                    "API Docs Fetch Error : " +
                    (!!error.response
                        ? `${error.response.status}! - ${error.response.data.errorMessage}`
                        : error.message)
                )
            );

        })
        // eslint-disable-next-line
    }, []); // [] is required to make sure that it runs only once

    return (
        <Container style={{ marginTop: "20px", padding: "10px" }}>
            <h3>API Docs</h3>
            <ComponentLoader isLoading={isLoading} />
            {!isLoading && (
                <Paper className={classes.paper}>
                    {!!docs && docs.length > 0 && (
                        <Table className={classes.table} size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Version</TableCell>
                                    <TableCell>Description</TableCell>
                                    <TableCell>Dev Url</TableCell>
                                    <TableCell>Live Url</TableCell>
                                    <TableCell>API Spec</TableCell>
                                    <TableCell>Status</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {docs.map(item => {
                                    return (
                                        <TableRow key={item.id}>
                                            <TableCell>
                                                <Link
                                                    color="inherit"
                                                    component={RouterLink}
                                                    to={`/dev/api-docs/${item.id}`}
                                                    underline="none"
                                                ><b>{item.name}</b></Link>
                                            </TableCell>
                                            <TableCell>{item.version}</TableCell>
                                            <TableCell>{item.description}</TableCell>
                                            <TableCell>{item.devUrl}</TableCell>
                                            <TableCell>{item.liveUrl}</TableCell>
                                            <TableCell>{`${item.specType} (${item.specVersion})`}</TableCell>
                                            <TableCell>
                                                <StatusChip status={item.status} />
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    )}
                </Paper>
            )}
        </Container>
    )
}
